export default {
  myFiles: 'Moji dokumenti',
  newDocument: 'Novi dokument',
  messages: 'Poruke',
  addresses: 'Adrese',
  newAddress: '+ Nova adresa',
  aboutUs: 'O nama',
  addArticle: 'Dodaj artikal',
  addAttribute: 'Dodaj atribut',
  addBank: 'Dodaj banku',
  addBlog: 'Dodaj novosti',
  addBrand: 'Dodaj brend',
  addCategory: 'Dodaj kategoriju',
  addCompany: 'Dodaj kompaniju',
  addCountry: 'Dodaj državu',
  addCurrency: 'Dodaj valutu',
  addCustomerBankAccount: 'Dodaj korisnički račun',
  accountDetails: 'Detalji o profilu',
  addExpressPost: 'Dodaj brzu poštu',
  addInterestsArea: 'Dodaj delatnost',
  addMeasurementUnit: 'Dodaj jedinicu mere',
  addPoll: 'Dodaj anketu',
  addProductSale: 'Dodaj akciju',
  areYourSureEmptyShoppingCart: 'Da li ste sigurni da želite isprazniti košaricu?',
  addTab: 'Dodaj tab',
  blog: 'Blog',
  addTown: 'Dodaj grad',
  addToCart: 'Dodaj u korpu',
  addToCart2: 'U korpu',
  docDate: 'Datum dok',
  account: 'Konto',
  owes: 'Duguje',
  comment: 'Komentar',
  accountNumber: 'Broj računa',
  claims: 'Potražuje',
  paymentTerm: 'Rok plaćanja',
  bookingDateShort: 'Datum knj',
  addUser: 'Dodaj korisnika',
  addVariation: 'Dodaj varijaciju',
  apply: 'Primeni',
  article: 'Proizvod',
  areYouSureArticle: 'Jeste li sigurni da želite izbrisati artikal {article}?',
  areYouSureAttribute: 'Jeste li sigurni da želite izbrisati atribut {attribute}?',
  areYouSureAttributeArticle: 'Jeste li sigurni da želite izbrisati atribut?',
  areYouSureAttributeValue:
    'Jeste li sigurni da želite izbrisati {attributeValue} vrednost atributa?',
  areYouSureBank: 'Jeste li sigurni da želite izbrisati banku {bank}?',
  areYouSureBlog: 'Jeste li sigurni da želite izbrisati novosti {blog}?',
  areYouSureBrand: 'Jeste li sigurni da želite izbrisati brend {brand}?',
  areYouSureCategory: 'Jeste li sigurni da želite izbrisati kategoriju {category}?',
  areYouSureCompany: 'Jeste li sigurni da želite izbrisati kompaniju {company}?',
  areYouSureCountry: 'Jeste li sigurni da želite izbrisati državu {country}?',
  areYouSureCurrency: 'Jeste li sigurni da želite izbrisati valutu {currency}?',
  areYouSureCustomerBankAccount:
    'Jeste li sigurni da želite izbrisati korisnički bankovni račun {bankAccount}?',
  areYouSureExpressPost: 'Jeste li sigurni da želite izbrisati brzu poštu {post}?',
  areYouSureInterestsArea: 'Jeste li sigurni da želite izbrisati delatnost {area}?',
  areYouSureProductSale: 'Jeste li sigurni da želite izbrisati akciju {productSale}?',
  areYouSureSelected: 'Jeste li sigurni da želite izbrisati odabrane zapise?',
  areYouSureTab: 'Jeste li sigurni da želite izbrisati tab {tab}?',
  areYouSureTown: 'Jeste li sigurni da želite izbrisati grad {town}?',
  areYouSureUser: 'Jeste li sigurni da želite izbrisati korisnika {user}?',
  areYouSureCancelOrder: 'Da li ste sigurni da želite otkazati narudžbu?',
  areYouSureApproveOrder: 'Da li ste sigurni da želite odobriti narudžbu?',
  areYouSureDeleteShoppingCart: 'Da li ste sigurni da želite izbrisati korpu?',
  shoppingCartNotConcluded: 'Trenutno imate nezaključenu korpu.',
  shoppingCartItemsReplacement: 'Stavke u korpi će biti zamenjene stavkama iz sačuvane korpe.',
  doYouWantToContinue: 'Želite li nastaviti?',
  thereAreCurrentlyNoSavedShoppingCarts: 'Trenutno nema sačuvanih korpi.',
  articleDetails: 'Detalji artikla',
  articleDetailsInfo: 'Unesite detalje artikla',
  articles: 'Artikli',
  attributes: 'Atributi',
  banks: 'Banke',
  blogs: 'Novosti',
  brands: 'Brendovi',
  brand: 'Brend',
  service: 'Servis',
  cancel: 'Otkaži',
  newRequest: 'Novi zahtev',
  contactPerson: 'Kontakt osoba',
  categories: 'Kategorije',
  category: 'Kategorija',
  serialNumber: 'Serijski broj',
  productCode: 'Šifra proizvoda',
  checkout: 'Naplata',
  download: 'Preuzmi',
  actions: 'Akcije',
  sales: 'Akcije',
  folderIsEmpty: 'Vaša mapa sa dokumentima je prazna',
  physicalPersons: 'Fizička lica',
  goToCheckout: 'Idi na naplatu',
  choose: 'Izaberite',
  chooseOptions: 'Izaberite opcije',
  contact: 'Kontakt',
  onlineShopping: 'Onlajn kupovina',
  ord: 'Rbr',
  myAccount2: 'Moj nalog',
  myArticles: 'Moji proizvodi',
  followUsOnSocialMedia: 'Pratite nas na društvenim mrežama',
  deliveryAndPayment: 'Dostava i plaćanje',
  complaintsAndReturns: 'Reklamacija i povrati',
  securityAndPrivacy: 'Sigurnost i privatnost',
  termsOfService: 'Uslovi korišćenja i kupovine',
  youNeedHelp: 'Treba vam pomoć?',
  from: 'Od',
  to: 'Do',
  title: 'Naslov',
  markAllAsRead: 'Označi sve kao pročitano',
  faq: 'Česta pitanja',
  howToRegister: 'Kako se registrovati?',
  shoppingHelp: 'Pomoć pri kupovini',
  bonusProgramRules: 'Pravila Bonus programa',
  comingSoon: 'Uskoro',
  companies: 'Kompanije',
  countries: 'Države',
  countryDetails: 'Detalji države',
  countryDetailsInfo: 'Unesite detalje države',
  viewFinances: 'Pogledaj finansije',
  coupons: 'Kuponi',
  currencies: 'Valute',
  customerBankAccounts: 'Korisnički računi',
  profileDashboard: 'Dashboard',
  defaultAddress: 'Sledeće adrese će se prema zadatim podešavanjima koristiti na stranici za naplatu.',
  delete: 'Izbriši',
  currentDebt: 'Trenutno zaduženje',
  deleteArticle: 'Izbriši artikal',
  paymentTerms: 'Uslovi plaćanja',
  deleteAttribute: 'Izbriši atribut',
  debtOutsideCurrency: 'Dug van valute',
  deleteBank: 'Izbriši banku',
  deleteBlog: 'Izbriši novosti',
  edit: 'Izmeni',
  approvedDebt: 'Odobreno zaduženje',
  deleteBrand: 'Izbriši brend',
  deleteCategory: 'Izbriši kategoriju',
  notSetAnyAddressYet: 'Još niste postavili nijednu adresu.',
  deleteCompany: 'Izbriši kompaniju',
  deleteCountry: 'Izbriši državu',
  deleteCurrency: 'Izbriši valutu',
  deleteCustomerBankAccount: 'Izbriši korisnički bankovni račun',
  deleteExpressPost: 'Izbriši brzu poštu',
  deleteInterestsArea: 'Izbriši delatnost',
  deleteProductSale: 'Izbriši akciju',
  deleteSelected: 'Izbriši odabrano',
  deleteTab: 'Izbriši tab',
  deleteTown: 'Izbriši grad',
  deleteUser: 'Izbriši korisnika',
  deleteVariationImage: 'Jeste li sigurni da želite izbrisati sliku varijacije?',
  details: 'Detalji',
  detailsInfo: 'Unesite detalje',
  editArticle: 'Ažuriraj artikal',
  editAttribute: 'Ažuriraj atribut',
  editBank: 'Ažuriraj banku',
  editBlog: 'Ažuriraj novosti',
  editBrand: 'Ažuriraj brend',
  editCategory: 'Ažuriraj kategoriju',
  editCompany: 'Ažuriraj kompaniju',
  editCountry: 'Ažuriraj državu',
  editCurrency: 'Ažuriraj valutu',
  editCustomerBankAccount: 'Ažuriraj korisnički račun',
  editExpressPost: 'Ažuriraj brzu poštu',
  editInterestArea: 'Ažuriraj delatnost',
  editPoll: 'Ažuriraj anketu',
  editProductSale: 'Ažuriraj akciju',
  editTab: 'Ažuriraj tab',
  editTown: 'Ažuriraj grad',
  editUser: 'Ažuriraj korisnika',
  expressPosts: 'Brze pošte',
  forgotPassword: 'Zaboravljena lozinka',
  greetings: 'Zdravo',
  homePageTitle: 'Početna',
  highlightedCategories: 'Izdvojeno',
  import: 'Importuj',
  importArticles: 'Importuj artikle',
  interestsAreas: 'Delatnosti',
  cancel2: 'ODUSTANI',
  cancel3: 'Odustani',
  login: 'Prijava',
  logIn: 'Prijavi se',
  logout: 'Odjava',
  measurementUnits: 'Jedinice mere',
  myAccount: 'Moj profil',
  delete2: 'IZBRIŠI',
  myProfile: 'Profil',
  news: 'Vesti',
  newArticles: 'Novi proizvodi',
  no: 'Ne',
  attention: 'Pažnja',
  warning: 'Upozorenje',
  areYouSureYouWantToDeleteAcc: 'Da li sigurno želite izbrisati vaš račun? Unesite lozinku da biste izbrisali vaš račun.',
  areYouSureYouWantToDeleteAddress: 'Jeste li sigurni da želite ukloniti odabranu adresu?',
  noItemSelected: 'Nema odabranih zapisa',
  noRecords: 'Nema rezultata prema traženim parametrima',
  notFound: 'Tražena stranica nije pronađena',
  orderArticles: 'Artikli u korpi',
  orders: 'Narudžbe',
  polls: 'Ankete',
  priceRange: 'Cenovni rang',
  productSales: 'Akcije',
  recentlyViewdItems: 'Ranije ste gledali',
  register: 'Registracija',
  resetFilters: 'Poništi filtere',
  rma: 'Prijavljene nepravilnosti (RMA)',
  uploadAttachment: 'Priložite slike, datoteke...',
  rmaForm: 'Reklamacije',
  save: 'Sačuvaj',
  saveArticle: 'Sačuvaj artikal',
  saveCategory: 'Sačuvaj kategoriju',
  saveCountry: 'Sačuvaj državu',
  search: 'Pretraga',
  find: 'Unesite minimalno 3 karaktera...',
  selectAction: 'Izaberite akciju',
  shoppingCart: 'Korpa',
  tabs: 'Tabovi',
  terms: 'Uslovi korišćenja',
  townDetails: 'Detalji grada',
  townDetailsInfo: 'Unesite detalje grada',
  towns: 'Gradovi',
  total: 'Ukupno',
  amount: 'Iznos',
  topBrands: 'Top brendovi',
  userProfile: 'Korisnički profil',
  users: 'Korisnici',
  userArticles: 'Proizvodi odabrani za vas',
  viewAll: 'Vidi sve',
  viewAllFrom: 'Vidi sve iz',
  addToCartSuccessMessage: 'Upravo ste dodali artikal u <br/> korpu: ',
  continueShopping: 'Nastavi kupovinu',
  clearShoppingCart: 'Isprazni korpu',
  updateShoppingCart: 'Ažuriraj korpu',
  goToShoppingCart: 'Idi u korpu',
  wishlist: 'Lista želja',
  addToWishlist: 'Dodaj u listu želja',
  yes: 'Da',
  reviews: 'Recenzija',
  tabReviews: 'Recenzije',
  writeReview: 'Unesite vašu recenziju',
  submitReview: 'Pošalji recenziju',
  anonymous: 'Anonimno',
  linkedArticles: 'Povezani proizvodi',
  quickPreview: 'Brzi pregled',
  loginRegisterTitle: 'Prijava / Kreiranje računa',
  loginTitle: 'Prijava',
  loginSubTitle: 'Ukoliko imate korisnički račun prijavite se.',
  loginButton: 'PRIJAVA',
  registerTitle: 'Zatražite korisnički račun',
  registerSubTitle: 'Popunite tražene informacije i naš tim će vas kontaktirati u najkraćem roku, te ćemo vam izraditi korisnički račun. Hvala!',
  chooseCountry: 'Izaberite državu',
  chooseTown: 'Izaberite grad',
  registerSectionLoginDataTitle: 'Podaci za prijavu',
  acceptTerms: 'Prihvatam uslove korišćenja',
  registerSubmit: 'Zatraži račun',
  repeatOrder: 'Ponovi narudžbu',
  close: 'Zatvori',
  defaultSort: 'Zadato sortiranje',
  sortByRating: 'Sortiraj po oceni',
  sortByDateOldest: 'Sortiraj po datumu objave: starije prema novom',
  sortByDateNewest: 'Sortiraj po datumu objave: novo prema starijem',
  sortByPriceLow: 'Sortiraj po ceni: niža prema višoj',
  sortByPriceHigh: 'Sortiraj po ceni: viša prema nižoj',
  pagingResults: 'Prikazuje se {fromResults} - {toResults} od {totalItems} rezultata',
  showMore: 'Prikaži više',
  productIsAvalible: 'Proizvod je dostupan',
  productIsAvalibleToOrder: 'Proizvod je dostupan po narudžbi',
  deliveryTimeDays: 'Vreme isporuke je {days} dana od narudžbe proizvoda',
  itemIsAvalibleContactRepresentative: 'Artikal je dostupan po narudžbi. Molimo kontaktirajte vašeg prodajnog predstavnika.',
  availableOnRequest: 'Dostupno na upit',
  requestPresentation: 'Zatraži prezentaciju',
  howDoYouRateThisProduct: 'Kako ocenjujete ovaj proizvod?',
  administrator: 'Administrator',
  passwordRecovery: 'Oporavak lozinke',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Unesite vašu e-mail adresu ispod i poslaćemo vam uputstva za resetovanje!',
  reset: 'Resetuj',
  remembered: 'Zapamćeno',
  finances: 'Finansije',
  allRightsReserved: 'Sva prava zadržana',
  updateAddress: 'Ažuriraj adresu',
  state: 'Država',
  chooseState: 'Izaberite državu',
  listIsEmpty: 'Lista je prazna',
  noResultsAccordingToTheGivenParameters: 'Nema rezultata prema zadatim parametrima',
  termsOfUseIsMandatory: 'Polje Uslovi korišćenja je obavezno',
  resetPassword: 'Reset lozinke',
  accVerificationInProgress: 'Verifikacija računa u toku',
  accVerification: 'Verifikacija računa',
  verificationLinkHasExpired: 'Verifikacioni link je istekao. Molimo kontaktirajte naše administratore: support@eurosan.ba ili +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'Upravo ste dodali artikal u korpu:',
  manufacturer: 'Proizvođač',
  productName: 'Naziv proizvoda',
  shoppingCarts: 'Korpe',
  preview: 'Pregled',
  documentName: 'Naziv dokumenta',
  status: 'Status',
  orderNumber: 'Broj narudžbe',
  orderer: 'Naručilac',
  date: 'Datum',
  document: 'Dokument',
  delivery: 'Dostava',
  deliverTo: 'Dostaviti na',
  discount: 'Rabat',
  savingsByUsingPromoCode: 'Ušteda korišćenjem promo koda',
  itemAddedToCart: 'Artikal dodat u korpu.',
  articlesOnSale: 'Artikli na akciji',
  controlPanel: 'Kontrolna tabla',
  tags: 'Tagovi',
  totalAmountWithDelivery: 'Ukupno sa dostavom',
  youHaveNotPlacedAnorderYet: 'Niste još uvek napravili narudžbu',
  quantity: 'Količina',
  amountWithoutVat: 'Iznos bez PDV-a',
  vatAmount: 'Iznos PDV-a',
  orderNo: 'Narudžba br',
  days: 'dana',
  time: 'Vreme',
  quantity2: 'KOLIČINA',
  rejectOrd: 'Odbij nar',
  approveOrd: 'Odobri nar',
  wishListIsEmpty: 'Lista želja prazna',
  sale: 'AKCIJA',
  totalWithoutTax: 'Ukupno bez poreza',
  sendRequest: 'POŠALJI ZAHTEV',
  promoCode: 'Promo kod',
  send: 'Pošalji',
  registrationCode: 'Šifra prijave',
  created: 'Kreirano',
  giftCard: 'Poklon kod',
  changePassword: 'Promena lozinke',
  emailAddress: 'Email adresa',
  oldPassword: 'Stara lozinka',
  deleteUserAcc: 'IZBRIŠI KORISNIČKI RAČUN',
  permanentlyDeletedAcc: 'Korisnički račun će biti trajno obrisan',
  confirmNewPassword: 'Potvrdite novu lozinku',
  passwordConfirmation: 'Potvrda lozinke',
  newPassword: 'Nova lozinka',
  newPassLeaveBlank: 'Nova lozinka (ostavite prazno ukoliko ne želite menjati)',
  currentPassLeaveBlank: 'Trenutna lozinka (ostavite prazno ukoliko ne želite menjati)',
  areasOfInterest: 'Interesna područja',
  chooseAreaOfInterest: 'Izaberite interesna područja',
  totalTax: 'Ukupno poreza',
  price: 'Cena',
  price2: 'CENA',
  newAddress2: 'Nova adresa',
  show: 'Prikaži',
  stock: 'Stanje',
  yourTotalDebtIs: 'Vaše ukupno zaduženje iznosi',
  isInStock: 'Ima na stanju',
  print: 'Print',
  signUpForTheNewsletter: 'Prijavite se na newsletter',
  latestInformations: 'Dobijte sve najnovije informacije o događajima, rasprodajama i ponudama.',
  subscribe: 'Pretplatite se',
  aboutEurosanGroup: 'O Eurosan grupaciji',
  responsibleBusiness: 'Odgovorno poslovanje',
  noDataToAccordingData: 'Nema podataka prema traženim parametrima',
  jobAtEurosan: 'Posao u Eurosanu',
  vpc: 'VPC',
  products: 'proizvoda',
  phoneNumber: 'Broj telefona',
  tax: 'PDV',
  defaultAddress2: 'Zadata adresa',
  totalWithVat: 'Ukupno sa PDV',
  totalWithoutVat2: 'Ukupno bez PDV',
  summary: 'Sažetak',
  warranty: 'Garancija',
  zipCode: 'Zip kod',
  indeterminate: 'Neodređeno',
  description: 'Opis',
  completeSolutionsForYourBusiness: 'Kompletna rešenja za uspeh Vašeg poslovanja',
  whoAreWe: 'KO SMO MI',
  about: {
    aboutEurosan: 'Eurosan Ecotime grupacija nastala je 1998. godine inspirisana željom za zdravijim i srećnijim radnim prostorima. Naš cilj je jasan: biti Vaš pouzdan partner u održavanju čistoće, higijene i sigurnosti. Verujemo da čisto i sigurno radno okruženje pokreće uspeh.',
    aboutEurosan2: '"Zdravije, sigurnije, produktivnije" - to je naše obećanje Vama!',
    aboutEurosan3: 'Kroz naše sveobuhvatne usluge i proizvode - od profesionalnog čišćenja do ekološki prihvatljivih proizvoda i zaštitne opreme - mi stvaramo prostore u kojima ljudi dišu lakše, rade efikasnije i žive zdravije.',
    aboutEurosan4: 'Odlučite se za nas i pridružite nam se u stvaranju zdravije i sigurnije budućnosti.',
    ourMission: 'NAŠA MISIJA',
    mission: 'Biti vaš pouzdani partner u stvaranju čistog, sigurnog i održivog okruženja kroz prilagođena rešenja i izuzetnu uslugu.',
    ourVision: 'NAŠA VIZIJA',
    vision: 'Postati lider u pružanju održivih i prilagođenih rešenja za čistiju, zdraviju i sigurniju budućnost, uvek stavljajući potrebe naših klijenata na prvo mesto.',
    ourValues: 'NAŠE VREDNOSTI',
    values: 'Naše temeljne vrednosti označavaju ono što jesmo, što radimo i način na koji to radimo, a one su visok kvalitet usluga i proizvoda, znanje o higijeni i briga o sigurnosti i zdravlju ljudi.',
    whyChooseUs: 'ZAŠTO NAS ODABRATI?',
    efficiency: 'UČINKOVITOST:',
    efficiencyText: 'Čistite pametnije, radite manje.',
    improvedHygiene: 'POBOLJŠANA HIGIJENA:',
    improvedHygieneText: ' Izvanredan nivo higijene za svaki prostor.',
    effectiveCleaning: 'DELOTVORNO ČIŠĆENJE:',
    effectiveCleaningText: ' Snaga čistoće u svakoj ambalaži.',
    improvedWorkerSafety: 'POBOLJŠANA SIGURNOST RADNIKA:',
    improvedWorkerSafetyText: ' Zaštitite svoje radnike vrhunskom zaštitnom opremom.',
    improvedDineExperience: 'POBOLJŠANO GASTRONOMSKO ISKUSTVO:',
    improvedDineExperienceText: ' Atmosfera koja odiše luksuzom i kvalitetom.',
    greaterGuestSatisfaction: 'VEĆE ZADOVOLJSTVO GOSTIJU:',
    greaterGuestSatisfactionText: ' Ekološki prihvatljiva hotelska kozmetika vrhunskog kvaliteta.',
    timeSaving: 'UŠTEDA VREMENA:',
    timeSavingText: ' Uštedite vreme i energiju - prepustite brigu o čišćenju nama.',
    longerEquipmentLife: 'DUŽI VEK TRAJANJA OPREME:',
    longerEquipmentLifeText: ' Za bezbrižnost - vaša oprema u sigurnim rukama našeg servisa.',
    atService: 'Ponosno smo na usluzi više od ',
    threeThousandClients: '3.000 klijenata',
    inCountries: 'u BiH, Srbiji i Crnoj Gori',
    yearsOfExistence: 'Godina postojanja',
    numberOfEmployees: 'Zaposlenih',
    activeArticles: 'Aktivnih artikala',
  },
  recentBlogs: 'Nedavne vesti',
  readMore: 'Pročitaj više',
  searchFor: 'Pretraga',
  archive: 'Arhiva',
  payment: 'Plaćanje',
  deliveryAddress: 'Adresa za dostavu',
  deliverHere: 'Dostaviti ovde',
  deliveryAddressValidationMessage: 'Molimo Vas da unesete bar jednu adresu za dostavu pre nego što nastavite sa procesuiranjem narudžbe',
  deliveryMethod: 'Način dostave',
  free: 'Besplatno',
  deliveryTime: 'Vreme isporuke 2 do 3 radna dana',
  personalPickup: 'Lično preuzimanje',
  personalVisitToTheBranch: 'Lični odlazak u poslovnicu',
  ourDelivery: 'Naša dostava',
  deliverySevenDays: 'Vreme isporuke cca. 7 dana',
  orderAmountFromText: '*Iznosom narudžbe od ',
  getFreeDeliveryText: ' KM ostvarujete besplatnu dostavu',
  articlesInShoppingCart: ' artikala u korpi',
  orderTotalAmountWithoutVat: 'Ukupno narudžba (bez PDV): ',
  orderTotalBruttoWeight: 'Ukupna kilaža ',
  promoCodeDiscount: '*Ušteda prilikom korišćenja promo koda: ',
  postage: 'Poštarina',
  totalOrderAmountWithPostage: 'Ukupno s poštarinom: ',
  paymentMethod: 'Način plaćanja',
  note: 'Napomena',
  acceptTermsOfUse: 'Prihvatam uslove korišćenja',
  back: 'Nazad',
  placeOrder: 'Zaključi narudžbu',
  nextStep: 'DALJE',
  complaints: {
    complaints: 'Reklamacije',
    privateBuyers: 'Za privatne kupce:',
    text1: 'Ukoliko ustanovite, prilikom prve upotrebe (unutar 7 dana od prijema), da je proizvod koji ste dobili neispravan, molimo Vas da nas kontaktirate i sledite navedene korake:',
    text2: 'Pošaljite nam informacije sa brojem narudžbe, brojem računa ili vašim korisničkim imenom i opisom reklamacije putem',
    emailAddress: ' e-mail adrese ',
    phone: 'ili telefonom na ',
    text3: 'Poslaćemo Vam potvrdu prijema reklamacije i, na osnovu Vašeg opisa reklamacije, informaciju o tome može li se proizvod zameniti za novi i može li se za proizvod vratiti novac.',
    text4: 'U slučajevima kada se proizvod može zameniti za novi i kada se za proizvod može vratiti novac, na Vašu adresu šaljemo dostavnu službu koja prikuplja reklamirani proizvod i vraća na naše skladište. Vaša obaveza je da proizvod zapakujete i spremite za preuzimanje brze pošte u originalnoj ambalaži sa svim dodacima i dokumentacijom koju ste dobili uz proizvod. Kada proizvod stigne na skladište, nakon što bude pregledan, šaljemo Vam obaveštenje o povratu novca/slanju zamenskog proizvoda. Povrat novca/zamena za novi proizvod biće odrađena unutar 2-3 dana, a najkasnije nakon 15 dana. U suprotnom nas kontaktirajte telefonom na 080 080 080 ili e-mailom na webshop@eurosan.ba',
    text5: 'Ako je ambalaža oštećena nemojte preuzimati proizvod, već dostavljaču skrenite pažnju na oštećenje ambalaže i zatražite da proizvod vrati u Eurosan. Ako kupac ne reklamira oštećenje ambalaže dostavljaču u trenutku preuzimanja proizvoda, smatra se da je preuzeo proizvod sa neoštećenom ambalažom.',
    text6: 'U slučaju da proizvod koji ste dobili ne odgovara slikom ili specifikacijom proizvodu koji ste naručili, isti možete zameniti ili vratiti u zamenu za novac unutar 7 dana od prijema. Za ostvarivanje ovog prava, potrebno je neoštećeni proizvod poslati u originalnom pakovanju sa svom opremom i dokumentacijom sa kojom je proizvod bio originalno isporučen.',
    businessCustomers: 'Za poslovne kupce: ',
    text7: 'Poslovni kupci popunjavaju obrazac zvan "Reklamacije" pomoću kojeg šalju reklamacije preduzeću Eurosan d.o.o. Na eurosan.ba web shopu u odeljku "Moj profil" se nalazi obrazac koji popunjavate na način da upišete kontakt osobu, naziv i šifru proizvoda, brend, serijski broj, upišete opis, priložite sliku, te napišete broj računa. Na kraju kliknete pošalji, a na istom mestu možete pratiti stanje vaše reklamacije, da li je na čekanju ili završena. Na isti način možete poslati zahtev ukoliko trebate servisirati mašinu koja ne radi. U tom slučaju je veoma bitno poslati slike kako bi Eurosan serviseri mogli tačno znati o čemu se radi.',
    text8: 'Za sve dodatne informacije možete kontaktirati svog prodajnog predstavnika, pozvati nas na',
    text9: '080 080 080 ili poslati e-mail na ',
  },
  contactUs: {
    commercialist: 'Komercijalista',
    eurosan: 'Eurosan d.o.o.',
    workTimeText: 'Radno vreme',
    workTime1: 'Ponedeljak - Petak: 07:30-16:00',
    workTime2: 'Subota (od 6. do 10. meseca): 08:00-12:00',
    address1: 'Bišće polje bb, 88000 Mostar',
    ecotime: 'Ecotime d.o.o.',
    workTime3: 'Ponedeljak - Petak: 08:00-16:00',
    workTime4: 'Subota: 08:00-12:00',
    address2: 'Lužansko polje 7, 71210 Ilidža',
    eurosanBl: 'Eurosan Banja Luka d.o.o.',
    workTime5: 'Subota: 09:00-13:00',
    address3: 'Jovana Bijelića bb, 78000 Banja Luka',
  },
  FAQ: {
    faq: 'Česta pitanja / FAQ',
    text1: ' Kako bismo olakšali snalaženje na našem web shopu, odgovorili smo na vaša najčešća pitanja. Verujemo da će vam odgovori pomoći kako biste što lakše, brže i bez nedoumica izvršili narudžbu željenog proizvoda.',
    q1: 'Kako se registrovati i napraviti profil?',
    text2: 'Kada otvorite naš web shop trebate zatražiti korisnički račun popunjavanjem traženih informacija. Nakon toga, naš tim će vas kontaktirati u najkraćem roku, te ćemo vam izraditi korisnički račun. Podaci koje trebate popuniti su: ime i prezime, kompanija, telefon, adresa, država, grad i interesna područja. Kada su u pitanju interesna područja, bitno je da označite onaj sektor kojem pripadate i kojim se bavite, bilo da su to zdravstvene ustanove, ugostiteljstvo, teretane, proizvodnja ili drugo ponuđeno.',
    text3: 'Možete kupovati bez pravljenja korisničkog računa, dakle kao gost. Potrebno je samo da unesete svoje podatke za dostavu, kao i email kako bismo vam mogli poslati potvrdu uspešne kupovine. Prijaviti se možete i preko Facebook i Google platformi koje su ponuđene.',
    q2: 'Kako naručiti proizvode?',
    text4: 'Naručivanje je veoma jednostavno, otvorite artikal koji želite naručiti, kliknete "u korpu", ili na brzom pregledniku kliknete odgovarajuću ikonicu koja se nalazi u desnom uglu slike. Kada završite sa dodavanjem artikala, otvorite korpu i idite na naplatu. Izaberite adresu za dostavu, način dostave i način plaćanja. Na kraju kliknete "zaključi narudžbu" i samim tim vaša narudžba je poslata. Na vašu email adresu stiže potvrda o izvršenoj narudžbi.',
    text5: 'Otvorite artikal koji želite naručiti i dodajte ga u korpu. Kada završite sa dodavanjem artikala, otvorite korpu i idite na naplatu. Ispunite podatke koji se traže od vas, a to su: ime i prezime, adresa, e-mail adresa, broj telefona i način plaćanja. Na kraju kliknete "zaključi narudžbu" i samim tim vaša narudžba je poslata. Na vašu email adresu stiže potvrda o izvršenoj narudžbi.',
    q3: 'Kako se vrši dostava?',
    text6: 'Poslovni kupci imaju više opcija dostave, a to su:',
    eurosanFreeDelivery: 'Eurosan besplatna dostava',
    postDelivery: 'dostava brzom poštom (Hrvatska pošta Mostar)',
    text7: 'lično preuzimanje u gradovima Mostar, Sarajevo i Banja Luka, odnosno u firmama Grupe',
    text8: 'Dostava se vrši brzom poštom. (Hrvatska Pošta Mostar uz vreme isporuke od 24h)',
    text9: 'Takođe, kupci mogu lično preuzeti narudžbu u jednoj od naših poslovnica u Mostaru, Sarajevu ili Banjoj Luci.',
    q4: 'Da li su vaši proizvodi pogodni za male biznise?',
    text10: 'Da, naši proizvodi su pogodni za velike kompanije, male biznise i preduzeća, kao i privatne korisnike i domaćinstva.',
    q5: 'Da li nudite prezentacije, trening ili podršku za vaše proizvode?',
    businessCustomers: 'Poslovni kupci:',
    text11: 'Poslovni kupci imaju opciju prezentacije proizvoda za određene proizvode poput mašina za čišćenje, određenog hemijskog programa, pomagala za čišćenje i sl. Za svaki kupljeni proizvod, kupci će imati trening gde će naši stručnjaci objasniti na koji način koristiti određeni proizvod. Takođe, na web shopu u sklopu svakog artikla se nalazi tehnička dokumentacija i način korišćenja proizvoda. Svaki kupac ima svog prodajnog predstavnika koji mu je tu kao podrška pri korišćenju proizvoda.',
    text12: 'Za sve nejasnoće, poslovni kupci uvek mogu kontaktirati naš besplatni info telefon',
    text13: ' 080 080 080 ili poslati nam e-mail na ',
    privateBuyers: 'Privatni kupci:',
    text14: 'Privatni kupci nam se putem besplatnog info telefona ',
    text15: 'ili putem drugih kanala komunikacije, uvek mogu obratiti za pomoć, savet i pravilan izbor proizvoda za njihovu potrebu u privatne svrhe i domaćinstva. Korisnička podrška je uvek dostupna.',
    q6: 'Koje kreditne kartice primate?',
    text16: 'Pored plaćanja gotovinom pouzeću, privatni kupci imaju opciju plaćanja i VISA, MasterCard i Maestro karticama.',
    q7: 'Da li dostavljate proizvode van BiH?',
    text17: 'Ne. Naše tržište je lokalno i obuhvata samo teritoriju Bosne i Hercegovine. Međutim, tu su naše dve partnerske firme, Interesta d.o.o. u Crnoj Gori i Ecotime d.o.o. Beograd u Srbiji. Za dodatne informacije, budite nas slobodni kontaktirati.',
  },
  newsletterConfirm: {
    backToShop: 'Povratak u prodavnicu',
    great: 'Odlično!',
    subscribed: 'Pretplatili ste se na Eurosan Njuzleter',
  },
  passwordResetSuccess: 'Lozinka je uspešno obnovljena',
  backToLogin: 'Povratak na prijavu',
  addSelected: 'Dodaj izabrane',
  service2: {
    text1: 'Eurosan d.o.o. garantuje da svi proizvodi do roka predaje kupcu poseduju kvalitet i da su isti bez nedostataka kao i da se mogu koristiti u skladu sa deklarisanom namenom, saglasno deklaraciji proizvođača.',
    text2: 'Kupac je u obavezi da prilikom prijema naručenog proizvoda isti pregleda i utvrdi da li ima nedostataka. Ukoliko se nedostaci utvrde, isti će biti otklonjeni u garantnom roku.',
    text3: ' Dužina garantnog roka je navedena u garantnom listu, ukoliko proizvod poseduje isti.',
    text4: ' U slučaju da je proizvod isporučen sa nedostatkom, kupac ima pravo na zamenu istog.',
    text5: 'Od reklamacija su izuzeti nedostaci koji su prouzrokovani nespretnim rukovanjem i suprotno uputstvu proizvođača za rukovanje proizvodima.',
    text6: 'Reklamacije proizvoda se priznaju uz priloženi fiskalni račun i ispravno popunjen garantni list kao dokaz kupovine. U slučaju reklamacije proizvoda, informacije o načinu prijave kvara ili slanju ovlašćenom servisu potražite na garantnom listu isporučenom uz proizvod ili nas ',
    text7: ' kontaktirajte na kontakt telefon 080 080 080 ili putem email adrese ',
    text8: 'Za popravku proizvoda isporučenih od strane Eurosan d.o.o. obezbedili smo kvalitetnu uslugu kako u garantnom periodu tako i van njega. Naše osoblje servisa vam je na raspolaganju za savete u vezi upotrebe proizvoda, kvarovima i mogućnostima popravke istog.',
  },
  areYouSureEmptyShoppingCart: 'Da li ste sigurni da želite da ispraznite korpu?',
  discountCode: 'Kod za popust',
  remove: 'Ukloni',
  yourCartIsEmpty: 'Vaša korpa je prazna',
  vpPrice: 'VP cena',
  howToRegisterText: 'Kako se registrovati - Vodič za korišćenje',
  downloadOurApp: 'Preuzmite našu aplikaciju',
  mobileAppViewText: 'Uživajte u brzoj i sigurnoj kupovini uz najbolje popuste i nove proizvode!',
  bih: 'Bosna i Hercegovina',
  jajce: 'Jajce',
  mostar: 'Mostar',
  sarajevo: 'Sarajevo',
  banjaluka: 'Banja Luka',
  sirokiBrijeg: 'Široki Brijeg',
  bihac: 'Bihać',
  kozarskaDubica: 'Kozarska Dubica',
  teslic: 'Teslić',
  derventa: 'Derventa',
  forms: {
    notValid: 'Uneti podaci nisu validni!',
    labels: {
      username: 'Korisničko ime',
      abbreviation: 'Skracenica',
      address: 'Adresa',
      email: 'E-maill adresa',
      articleType: 'Vrsta artikla',
      availableValues: 'Dostupne vrednosti',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      brand: 'Brend',
      catalogNumber: 'Kataloški broj',
      category: 'Kategorija',
      code: 'Šifra',
      company: 'Kompanija',
      content: 'Sadržaj',
      country: 'Država',
      countryName: 'Naziv države',
      defaultPrice: 'Podrazumevana cena',
      description: 'Opis',
      fax: 'Faks',
      interestsArea: 'Delatnost',
      isVisibleOnWeb: 'Vidljivo na webu',
      mpc: 'Maloprodajna cena',
      name: 'Naziv',
      nc: 'Nabavna cena',
      nettoWeight: 'Neto težina',
      officeNumber: 'Broj kancelarije',
      phone: 'Telefon',
      password: 'Lozinka',
      confirmPassword: 'Potvrdi lozinku',
      shortDescription: 'Kratak opis',
      symbol: 'Simbol',
      taxGroup: 'Poreska grupa',
      title: 'Naziv',
      town: 'Grad',
      townName: 'Naziv grada',
      unit: 'Jedinica',
      unitOfMeasure: 'Jedinica mere',
      videoUrl: 'Video link',
      vpc: 'Velprodažna cena',
      firstName: 'Ime',
      lastName: 'Prezime',
    },
    errors: {
      default: 'Dugodila se greška prilikom validacije.',
      email: 'Polje {field} nije validna e-mail adresa.',
      integer: 'Polje {field} mora biti broj.',
      minLength: 'Minimalno {count} karaktera.',
      required: 'Polje {field} je obavezno.',
      sameAs: 'Polje {field} i polje {field2} se ne poklapaju.',
      url: 'Polje {field} nije validan url.',
    },
  },
  tables: {
    email: 'E-mail',
    firstLastName: 'Ime i prezime',
    id: 'ID',
    name: 'Naziv',
    phone: 'Telefon',
    town: 'Grad',
    username: 'Korisničko ime',
  },
};
